var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Timeouts } from './framework/Timeouts';
export class Dm8000 {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        // other class properties and constructor
        this.blocks = {};
        this.mutePresets = {};
        this.pollIndex = 0;
        this.pollInfo = [];
        this.timeouts = new Timeouts();
        // controls
        this.detected = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const aliasesMatch = yield this.socket.send('SESSION get aliases', /^@ok\s+Instance\s+Tag\s+List:\s*\[\s*"(.+)"\s*\]/i, tags);
                const aliases = aliasesMatch[1].split(/"\s*"/);
                const ctrlDef = {
                    mute: ['Output_Mute', 'Input_Mute', 'Muted'],
                    volume: ['Output_Level', 'Input_Level', 'Level_dB'],
                };
                for (const alias of aliases) {
                    for (const ctrl of Object.keys(ctrlDef).sort()) {
                        for (const attr of ctrlDef[ctrl]) {
                            const attrMatch = yield this.socket.send(`get ${alias} ${attr} 1`, /^@er pitch command fail|^@ok\s+(\S+)\s+(.+\s+)?is\s+(\S+)/i, tags);
                            if (attrMatch[1]) {
                                if (!this.blocks[alias]) {
                                    this.blocks[alias] = {
                                        numChannels: 0,
                                        type: attrMatch[1],
                                    };
                                }
                                if (ctrl === 'mute' || ctrl === 'volume') {
                                    this.blocks[alias][ctrl] = attr;
                                }
                                else {
                                    throw new Error(`unexpected control type: ${ctrl}`);
                                }
                                break;
                            }
                        }
                    }
                }
                for (const [alias, block] of Object.entries(this.blocks)) {
                    const attr = (_a = block.mute) !== null && _a !== void 0 ? _a : block.volume;
                    const numChannelsMatch = yield this.socket.send(`get ${alias} ${attr} 0`, /^@er\s+.+must\s+be\s+1~(\d+)|^@ok\s+(\S+)\s+(.+\s+)?is\s+(\S+)/i, tags);
                    if (numChannelsMatch[1] !== undefined) {
                        block.numChannels = parseInt(numChannelsMatch[1], 10);
                    }
                }
                const detected = [];
                for (const [alias, block] of Object.entries(this.blocks)) {
                    const hasMute = block.hasOwnProperty('mute');
                    const hasVolume = block.hasOwnProperty('volume');
                    detected.push({
                        instanceTag: alias,
                        numChannels: block.numChannels,
                        type: block.type,
                        filters: {
                            amplifier: hasVolume,
                            assistiveListeningMute: hasMute,
                            assistiveListeningMuteStatus: hasMute,
                            assistiveListeningVolume: hasVolume,
                            audioInputMute: hasMute,
                            audioInputMuteStatus: hasMute,
                            audioInputVolume: hasVolume,
                            mics: hasMute,
                            micsMuteStatus: hasMute,
                            overflowRoomMute: hasMute,
                            overflowRoomMuteStatus: hasMute,
                            overflowRoomVolume: hasVolume,
                            preset: false,
                            receiveGain: false,
                            soundReinforcementMute: hasMute,
                            soundReinforcementMuteStatus: hasMute,
                            soundReinforcementVolume: hasVolume,
                            telephony: false,
                        },
                    });
                }
                return detected;
            }),
        };
        this.mute = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const [alias, index] = this.getAliasInfo(key);
                return this.getMute(alias, index, tags);
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const mutePresets = this.mutePresets[key];
                if (mutePresets) {
                    yield this.socket.send(`DEVICE recallPreset ${value ? mutePresets.mute : mutePresets.unmute}`, /^DEVICE\s+recallPreset/i, tags);
                }
                else {
                    const [alias, index, block] = this.getBlockInfo(key);
                    yield this.socket.send(`set ${alias} ${block.mute}${index} ${value ? '1' : '0'}`, /^@ok pitch command okay/i, tags);
                }
                return value;
            }),
            getKey: this.getKey.bind(this),
            validate: this.validate.bind(this), // happens before constructor binding
        };
        this.volume = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const [alias, index] = this.getAliasInfo(key);
                return yield this.getVolume(alias, index, tags);
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const [alias, index, block] = this.getBlockInfo(key);
                yield this.socket.send(`set ${alias} ${block.volume}${index} ${value.toFixed(1)}`, /^@ok pitch command okay/i, tags);
                return value;
            }),
            getKey: this.getKey.bind(this),
            range: (config, info) => __awaiter(this, void 0, void 0, function* () {
                if (info.volumeType === 'trim')
                    return { max: 0, min: -24, round: 0.1 };
                return { max: 0, min: -50, round: 0.1 };
            }),
            validate: this.validate.bind(this), // happens before constructor binding
        };
        // polling
        this.polls = [
            {
                function: this.poll.bind(this),
                intervalMs: 1000,
            },
        ];
        // bind callbacks
        this.getKey = this.getKey.bind(this);
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            this.blocks = {};
            this.mutePresets = {};
            this.pollIndex = 0;
            this.pollInfo.length = 0;
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.socket.sendAsync('exit');
            yield this.socket.send('3rdStart', /^@ok\s+3rd\s+control\s+start/i);
            try {
                yield this.socket.send('DEVICE get serialNumber', /^@ok\s+Device\s+Serial\s+Number:/i);
                return 'connected';
            }
            catch (_a) { }
            yield this.socket.sendAsync(`username ${credentials.username}`);
            yield this.timeouts.delay(500);
            const match = yield this.socket.send(`password ${credentials.password}`, /^(@ok)\s+Device\s+Host\s+Name|^@er\s+Current\s+username\s+is\s+invalid,\s+please\s+get\s+use\s+right\s+from\s+admin|^@er\s+Current\s+user\s+password\s+is\s+wrong/i);
            if (match[1] === 'undefined')
                return 'authFailed';
            return 'connected';
        });
    }
    // other class methods
    getAliasInfo(key) {
        var _a;
        const [, alias, index] = (_a = key.match(/([^.]+)(?:\.(\d+))?/)) !== null && _a !== void 0 ? _a : [];
        if (alias === undefined)
            throw new Error(`invalid key: ${key}`);
        return [alias, index === undefined ? '' : ` ${index}`];
    }
    getBlockInfo(key) {
        var _a;
        const [, alias, index] = (_a = key.match(/([^.]+)(?:\.(\d+))?/)) !== null && _a !== void 0 ? _a : [];
        if (alias === undefined)
            throw new Error(`invalid key: ${key}`);
        const block = this.blocks[alias];
        if (block === undefined)
            throw new Error(`no block for alias: ${alias}`);
        return [alias, index === undefined ? '' : ` ${index}`, block];
    }
    getKey(config) {
        if ('muteStatus' in config)
            return this.getKey(config.muteStatus); // preset mute
        const key = 'index' in config ? `${config.instanceTag}.${config.index}` : config.instanceTag;
        if (!(config.instanceTag in this.blocks)) {
            return `invalid.${key}`;
        }
        return key;
    }
    getMute(alias, index, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const block = this.blocks[alias];
            if (block === undefined)
                throw new Error(`no block for alias: ${alias}`);
            const match = yield this.socket.send(`get ${alias} ${block.mute}${index}`, /^@ok.+is\s+(mute|unmute)/i, tags);
            return match[1] === 'mute';
        });
    }
    getVolume(alias, index, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const block = this.blocks[alias];
            if (block === undefined)
                throw new Error(`no block for alias: ${alias}`);
            const match = yield this.socket.send(`get ${alias} ${block.volume}${index}`, /^@ok.+is\s+([+-]?\d+\.?\d*)/i, tags);
            return parseFloat(match[1]);
        });
    }
    poll() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.pollInfo.length <= 0) {
                yield this.socket.send('DEVICE get serialNumber', /^\@ok\s+Device\s+Serial\s+Number.*\s+(\S+)\s*/, ['poll', 'get.serialNumber']);
                return;
            }
            const pollInfo = this.pollInfo[this.pollIndex++];
            if (this.pollIndex >= this.pollInfo.length)
                this.pollIndex = 0;
            const [alias, index] = this.getAliasInfo(pollInfo.key);
            if (pollInfo.control === 'mute') {
                const mute = yield this.getMute(alias, index, ['poll', 'get.mute']);
                this.state.mutes.update(pollInfo.key, mute);
            }
            else {
                const volume = yield this.getVolume(alias, index, ['poll', 'get.volume']);
                this.state.volumes.update(pollInfo.key, volume);
            }
        });
    }
    validate(config, info) {
        return __awaiter(this, void 0, void 0, function* () {
            if ('muteStatus' in config) {
                // Store the mute and unmute preset names.
                const key = this.getKey(config);
                this.mutePresets[key] = {
                    mute: config.mutePreset,
                    unmute: config.unmutePreset,
                };
                // We can't validate the preset names on the DM8000, so just validate the mute status.
                config = config.muteStatus;
            }
            const block = this.blocks[config.instanceTag];
            if (block === undefined)
                return 'missing';
            if (!(info.type in block))
                return 'incompatible';
            if (block.numChannels > 0) {
                const index = config.index;
                if (index === undefined || index < 1 || index > block.numChannels) {
                    return 'incompatible';
                }
            }
            this.pollInfo.push({
                key: this.getKey(config),
                control: info.type,
            });
            return 'ok';
        });
    }
}
//static properties
Dm8000.channelsConfigName = 'dm8000ControlChannels';
Dm8000.driverType = 'socketDriver';
Dm8000.key = '-Ku0lpyEVxDpb7KUKfAb';
Dm8000.socketOptions = [
    {
        port: 4999,
        sendTerminator: '\r\n',
    },
];
